import React from 'react';
import { BfsDetaljer, BfsPlanlegging, BfsForvaltning } from '@byggforsk/fundament-icons';
import Box from '@mui/material/Box';

interface SeriesProps {
  seriesId?: number | null;
  size?: number | string;
}

const Series: React.FC<SeriesProps> = ({ seriesId, size = 20 }) => {
  if (!seriesId) return null;

  const colorForSeries = (id?: number | null) => {
    switch (id) {
      case 1:
        return '#52823B';
      case 2:
        return '#287891';
      case 3:
        return '#81710A';
      default:
        return undefined;
    }
  };

  const renderIcon = (Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>, color?: string) => (
    <Box
      component="span"
      sx={
        color
          ? {
              display: 'inline-flex',
              alignItems: 'center',
              '& svg': {
                color: color,
                fill: color,
                stroke: color,
              },
              '& svg path': {
                fill: `${color} !important`,
                stroke: `${color} !important`,
              },
            }
          : undefined
      }>
      <Icon width={size} height={size} style={color ? { color } : undefined} aria-hidden={color ? false : true} />
    </Box>
  );

  switch (seriesId) {
    case 1:
      return renderIcon(BfsPlanlegging, colorForSeries(1));
    case 2:
      return renderIcon(BfsDetaljer, colorForSeries(2));
    case 3:
      return renderIcon(BfsForvaltning, colorForSeries(3));
    default:
      return null;
  }
};

export default Series;
